import {createSelector} from "reselect";
import {getDoctorDashboardState} from "../../store/doctor-dashboard.selectors";

export const getPatientsState = createSelector(getDoctorDashboardState, state => state.patients);
